import { DataTableMeta, ActionsColumn } from '@otp/ui';
import { TFunction } from 'i18next';
import {
  MostQuerySuggestedTask,
  MostRequestHistoryListDocument,
  MostScheduledJobsDocument,
} from 'src/graphql/generated/graphql';
import { Play } from '@otp/icons';
import { RunCommand } from 'src/components/most/common/run-command';
import { ScheduleButton } from 'src/components/most/list/history/item/suggested-tasks/columns/actions/schedule-button';

export const getTableConfig = (
  data: MostQuerySuggestedTask[],
  store: {
    id: string;
    nationalStoreNumber: string;
  },
  { t }: { t: TFunction },
) => [
  {
    name: 'problemDefinition.name',
    label: t('common.description'),
    options: {
      setCellProps: () => ({
        style: {
          minWidth: '160px',
        },
      }),
      customBodyRender: (value: string) => value,
    },
  },
  {
    name: 'computersWithProblem',
    label: t('most.history-details.table.affected-devices'),
    options: {
      customBodyRender: (computersWithProblem: string[]) =>
        computersWithProblem.join(', '),
    },
  },
  {
    name: 'devices',
    label: t('most.history-details.table.devices-to-fix'),
    options: {
      isDesktopOnly: true,
      customBodyRender: (_: any) => {
        return t('most.history-details.table.all-affected-devices');
      },
    },
  },
  {
    name: 'actions',
    label: t('common.actions'),
    options: {
      setCellProps: () => ({
        style: {
          minWidth: '70px',
          textAlign: 'right',
        },
      }),
      customBodyRender: (_: any, column: DataTableMeta) => {
        const record = data[column.rowIndex] as MostQuerySuggestedTask;
        const command = {
          device: record.computersWithProblem as string[],
          nationalStoreNumber: store.nationalStoreNumber,
          triageId: record.problemDefinition?.triageId,
        };

        const actions = [
          {
            icon: (
              <RunCommand command={command}>
                <Play />
              </RunCommand>
            ),
          },
          {
            icon: (
              <ScheduleButton
                storeId={store.id}
                task={record}
                refetchQueries={[
                  MostScheduledJobsDocument,
                  MostRequestHistoryListDocument,
                ]}
              />
            ),
          },
        ];

        return <ActionsColumn icons={actions} className="flex justify-end" />;
      },
    },
  },
];
